import { FunctionComponent } from 'react';

type FilterIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
  disable?: boolean;
};

const FilterIcon: FunctionComponent<FilterIconProps> = ({
  width = 34,
  height = 34,
  active = false,
  disable = false,
}) => {
  const circleFill = active ? '#561BDC' : disable ? '#D5D5D5' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : disable ? '#8E8E8E' : '#1A1A1A';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-870 -1105)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(870 1105)"
          fill={circleFill}
        />
        <g transform="translate(817.788 934.985)">
          <g transform="translate(60.212 180.023)">
            <path
              d="M1,2.44a2.236,2.236,0,0,1,.1-.949A.9.9,0,0,1,1.491,1.1,2.236,2.236,0,0,1,2.44,1H17.56a2.236,2.236,0,0,1,.949.1.9.9,0,0,1,.393.393,2.236,2.236,0,0,1,.1.949v.6a1.943,1.943,0,0,1-.03.475.9.9,0,0,1-.128.279,1.941,1.941,0,0,1-.34.334L12.747,9.119a1.942,1.942,0,0,0-.34.334.9.9,0,0,0-.128.279,1.944,1.944,0,0,0-.03.475v4.705a1.022,1.022,0,0,1-.028.34.45.45,0,0,1-.119.176,1.021,1.021,0,0,1-.305.153l-3.06,1.224c-.331.132-.5.2-.629.171a.45.45,0,0,1-.284-.192,1.305,1.305,0,0,1-.075-.647V10.208a1.941,1.941,0,0,0-.03-.475.9.9,0,0,0-.127-.279,1.942,1.942,0,0,0-.34-.334L1.5,4.131a1.941,1.941,0,0,1-.34-.334.9.9,0,0,1-.127-.279A1.941,1.941,0,0,1,1,3.042Z"
              transform="translate(-1 -1)"
              fill="none"
              stroke={strokeColor}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default FilterIcon;
